<template>
  <div class="live_schedule">
    <van-action-sheet
      class="schedule_sheet"
      id="live-c"
      v-model="show"
    >
      <div class="sche_title">
        <van-icon
          color="#ff3f3f"
          name="notes-o"
        />日程
      </div>
      <div
        id="live-h"
        ref="warp"
        style="padding-top:.9rem"
      >
        <div class="sche_content">
          <van-loading
            size="14px"
            style="display:bolck;text-align:center;"
            v-if="!(scheList.length>0)"
          >loading...</van-loading>
          <div
            :style="'bottom:'+stepsBarH+'px'"
            class="steps_bar"
            v-if="scheList.length>0"
          ></div>
          <div
            :class="item<3?'end':''"
            :key="index"
            class="sche_item"
            v-for="(item,index) in scheList"
          >
            <div class="step">{{index+1}}</div>
            <div
              class="info"
              style="width: 80%"
            >
              <p class="date">
                {{item.startTime | moment('MM月DD日 HH:mm')}} ~ {{item.endTime | moment('MM月DD日 HH:mm')}}
                <!-- <span class="schedule_tag red" id="waa" v-if="compareDate(item.startTime,item.endTime)==1">进行中</span>
              <span  v-if="compareDate(item.startTime,item.endTime)==3"></span>
                <span class="schedule_tag"  v-if="compareDate(item.startTime,item.endTime)==2" id="waa1">已结束</span>-->
                <span
                  class="schedule_tag red"
                  id="waa"
                  v-if="item.state==1"
                >进行中</span>
                <span v-if="item.state==3"></span>
                <span
                  class="schedule_tag"
                  id="waa1"
                  v-if="item.state==2"
                >已结束</span>
              </p>
              <p class="sche_type">
                {{item.theme}}
                <span>{{item.speaker}}</span>
              </p>
              <template v-if="index>0">
                <div
                  :key="index1"
                  v-for="(advert ,index1) in item.advert"
                >
                  <img
                    src="https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=458113847,2800693724&fm=26&gp=0.jpg"
                    v-load="'oHallSchedule'"
                  />
                  <img src="https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=458113847,2800693724&fm=26&gp=0.jpg" />
                  <img src="https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=458113847,2800693724&fm=26&gp=0.jpg" />
                </div>
                <div
                  :key="index2"
                  class="sche_user"
                  v-for="(speaker,index2) in item.speaker"
                >
                  <img src="https://dss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3170379310,1742401393&amp;fm=111&amp;gp=0.jpg" />石静安
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import Bscroll from "better-scroll";
export default {
  // 热榜
  name: "live-schedule",
  data () {
    return {
      show: false, //是否显示助力排行榜
      stepsBarH: 0, //步骤条高度
      scheList: [], //日程列表
      startData: [],
      scroll: null,
      starttimeList: [],
      endtimeList: [],
      status: 0,
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
    }),
  },
  mounted () {
    this.getStepH();
    window.onresize = () => {
      this.getStepH();
    };
  },
  created () { },
  methods: {
    ...mapActions({
      getExhibitionSchedule: "login/getExhibitionSchedule",
    }),
    open () {
      this.show = true;
      this.scheList = [];
      this.getscheList();
      // this.getScrool();
    },

    //获取日程
    async getscheList () {
      let data = await this.getExhibitionSchedule(this.exhibitionId);
      console.log(data, "日程的获取");
      // let a = this.compareDate()
      // console.log(a)
      // 时间截取
      for (let i = 0; i < data.length; i++) {
        let date = data[i].date.substring(0, 11);
        let sttime = data[i].startTime.substring(11, 19);
        let entime = data[i].endTime.substring(11, 19);
        data[i].startTime = (date + sttime).replace(/\-/g, "/");
        data[i].endTime = (date + entime).replace(/\-/g, "/");
        data[i].state = this.compareDate(data[i].startTime, data[i].endTime);
      }
      this.scheList = data;
      this.$nextTick(() => {
        // this.compareDate()
        this.getStepH();
        this.geth();
      });
    },
    //创建一个滚动
    getScrool () {
      setTimeout(() => {
        // document.getElementById("waa").scrollIntoView();
      }, 100);
    },
    geth () {
      this.$nextTick(() => {
        if (document.getElementById("waa")) {
          document.getElementById("live-c").scrollTop = document.getElementById(
            "waa"
          ).offsetTop;
          console.log("进行中");
        } else {
          console.log("未开始");
        }
      });
    },
    //获取步骤条高度   每次数据刷新需要调用该方法
    getStepH () {
      let sumH = $(".sche_content").children(".sche_item:last-child").height();
      let dateH = $(".sche_content")
        .children(".sche_item:last-child")
        .children(".info")
        .children(".date")
        .height();
      this.stepsBarH = sumH - dateH;
      console.log(this.stepsBarH);
      console.log(sumH);
      console.log(dateH);
    },
    // 比较时间
    compareDate (statedate, enddate) {
      const stateTime = new Date(statedate).getTime();
      const Time = new Date().getTime();
      const endTime = new Date(enddate).getTime();
      console.log(stateTime, Time, endTime);
      if (stateTime < Time && Time < endTime) {
        return 1; //进行中
      } else if (endTime < Time) {
        return 2; //已结束
      } else {
        return 3; //未开始
      }
    },
  },
  beforeDestroy () {
    window.onresize = null;
  },
};
</script>

<style scoped lang="scss">
.schedule_tag {
  /*height: 0.28rem;*/
  font-size: 0.2rem;
  vertical-align: middle;
  padding: 0 0.08rem;
  border-radius: 0.03rem;
  display: inline-block;
  background: #e6e6e6;
  color: #666;
  margin-left: 0.2rem;
  transform: translateY(-0.02rem);
  &.red {
    background: #ff4550;
    color: #fff;
  }
}
.schedule_sheet {
  border-radius: 0.16rem 0.16rem 0 0;
  height: 9rem;
  .sche_title {
    height: 0.9rem;
    line-height: 0.9rem;
    background: url("../../assets/img/schedule_title.png");
    background-size: 100% 100%;
    font-size: 0.26rem;
    color: #333;
    text-align: center;
    letter-spacing: 0.03rem;
    padding-left: 0.03rem;
    position: fixed;
    z-index: 2;
    width: 100%;
    .van-icon {
      font-size: 0.28rem;
      line-height: 0.9rem;
      transform: translateY(0.02rem);
    }
  }
  .sche_content {
    padding: 0rem 0.3rem;
    position: relative;
    .steps_bar {
      width: 0.04rem;
      position: absolute;
      left: 0.55rem;
      z-index: -1;
      top: 0.5rem;
      bottom: 0;
      background: #ff4550;
    }
    .sche_item {
      display: flex;
      margin-top: 0.48rem;
      &.end {
        .sche_type {
          color: #999;
        }
      }
      .step {
        margin: 0.06rem 0.27rem 0 0;
        width: 0.52rem;
        height: 0.52rem;
        line-height: 0.54rem;
        border-radius: 50%;
        background: linear-gradient(to left, #ff416c, #ff4b2b);
        color: #fff;
        font-size: 0.26rem;
        text-align: center;
      }
      .date {
        line-height: 0.28rem;
        height: 0.28rem;
        font-size: 0.24rem;
        margin-bottom: 0.12rem;
      }
      .sche_type {
        line-height: 1.5em;
        color: #333;
        margin-bottom: 0.14rem;
        span {
          color: #666;
          margin-left: 0.3rem;
        }
      }
      .msg {
        display: flex;
        img {
          width: 0.84rem;
          height: 0.84rem;
          // object-fit: cover;
          display: block;
          margin-right: 0.12rem;
          border-radius: 0.03rem;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .sche_user {
        display: flex;
        color: #333;
        img {
          width: 0.36rem;
          height: 0.36rem;
          // object-fit: cover;
          display: block;
          margin-right: 0.1rem;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
